exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Dialog\n   ========================================================================== */\n.dialog {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  margin: auto;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 6px 17px 0 rgba(0, 0, 0, 0.16), 0 8px 14px 0 rgba(0, 0, 0, 0.18);\n  will-change: transform; }\n  .dialog .dialog__toolbar {\n    margin: 0; }\n\n.dialog__header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 60px 0 60px; }\n  .dialog__header--striped-title {\n    padding-bottom: 40px; }\n  .dialog__header--striped-icon {\n    padding-top: 0; }\n\n.dialog__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.dialog--align-left .dialog__header,\n.dialog--align-left .dialog__content {\n  text-align: left; }\n\n.dialog--align-center .dialog__header,\n.dialog--align-center .dialog__content {\n  text-align: center; }\n\n.dialog--align-right .dialog__header,\n.dialog--align-right .dialog__content {\n  text-align: right; }\n\n.dialog__title {\n  width: 100%; }\n  .dialog__title strong {\n    font-weight: 600; }\n  .dialog__title em {\n    color: #a4a4a4;\n    font-style: normal;\n    word-wrap: break-word;\n    word-break: break-all; }\n\n.dialog__icon {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  padding: 10px; }\n\n.dialog__toolbar {\n  justify-content: flex-end; }\n\n/* Density\n   ========================================================================== */\n.dialog--density-medium .dialog__content {\n  padding: 0 60px 40px 60px; }\n  .dialog--density-medium .dialog__content--no-header {\n    padding-top: 40px; }\n\n/* Sizes\n   ========================================================================== */\n.dialog--size-small {\n  width: 380px; }\n\n.dialog--size-medium {\n  width: 470px; }\n\n.dialog--size-large {\n  width: 640px; }\n\n.dialog--size-x-large {\n  width: 870px; }\n\n/* States\n   ========================================================================== */\n.dialog--state-active {\n  border-top: 3px solid #6acb4c; }\n  .dialog--state-active .dialog__icon {\n    color: #fff;\n    background-color: #6acb4c; }\n\n.dialog--state-inactive {\n  border-top: 3px solid #f54545; }\n  .dialog--state-inactive .dialog__icon {\n    color: #fff;\n    background-color: #f54545; }\n\n.dialog--state-warning {\n  border-top: 3px solid #eca03e; }\n  .dialog--state-warning .dialog__icon {\n    color: #fff;\n    background-color: #eca03e; }\n\n.dialog--state-info {\n  border-top: 3px solid #25b8d2; }\n  .dialog--state-info .dialog__icon {\n    color: #fff;\n    background-color: #25b8d2; }\n\n@media (max-width: 767px) {\n  .dialog {\n    width: 100%; }\n    .dialog--size-small {\n      width: 380px; }\n    .dialog--size-medium {\n      width: 470px; }\n  .dialog--density-medium .dialog__header {\n    padding: 15px 20px 0; }\n    .dialog--density-medium .dialog__header--striped-title {\n      padding-bottom: 15px; }\n    .dialog--density-medium .dialog__header--striped-icon {\n      padding-top: 0; }\n  .dialog--density-medium .dialog__content {\n    padding: 0 20px 15px; }\n    .dialog--density-medium .dialog__content--no-header {\n      padding-top: 15px; }\n  .dialog__icon {\n    width: 40px;\n    height: 40px; }\n  .dialog__content {\n    padding: 20px; } }\n\n@media (max-width: 420px) {\n  .dialog--size-small {\n    width: 100%; } }\n\n@media (max-width: 510px) {\n  .dialog--size-medium {\n    width: 100%; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};